module.exports = __webpack_public_path__ + "static/media/allergen_sesame.8e0c6adc.8e0c6adc.png";